/*
 * @Author: LZH
 * @Date: 2025-03-04 12:09:18
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-04-20 15:14:18
 * @Description: 
 */
export default [    //电子围栏
    {   
        path: "/enclosure/TransboundaryRecord",  
        name:'TransboundaryRecord',
        meta: { title: "越界记录",navId:2 },
        component:() => import("@/views/enclosure/TransboundaryRecord.vue")
    },
    {   
        path: "/enclosure/enclosureMap",  
        name:'enclosureMap',
        meta: { navId:2 },
        component:() => import("@/views/enclosure/enclosureMap.vue")
    }
]

